<ul class="esf-breadcrumbs">
  <ng-container *ngFor="let breadcrumb of currentBreadcrumbs; let i = index">
    <li class="esf-breadcrumb" [ngClass]="{'esf-breadcrumb--products': i === 0, 'esf-breadcrumb--is-current': i === currentBreadcrumbs.length - 1}">
      <a class="esf-breadcrumb__link" (click)="navigateTo(breadcrumb)" style="cursor: pointer;">
        <svg class="esf-icon esf-icon--has-text esf-breadcrumb__icon" width="16" height="16">
          <use [attr.xlink:href]="breadcrumb.icon"></use>
        </svg>
        <span class="esf-breadcrumb__title">{{ breadcrumb.title }}</span>
      </a>
    </li>
  </ng-container>
</ul>
